import { render, staticRenderFns } from "./feedbackMng.vue?vue&type=template&id=74b34f27&scoped=true"
import script from "./feedbackMng.vue?vue&type=script&lang=js"
export * from "./feedbackMng.vue?vue&type=script&lang=js"
import style0 from "./feedbackMng.vue?vue&type=style&index=0&id=74b34f27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b34f27",
  null
  
)

export default component.exports